// extracted by mini-css-extract-plugin
module.exports = {"ancillary":"AncillaryCard_ancillary__6qzms","ancillaryLink":"AncillaryCard_ancillaryLink__hpimC","content":"AncillaryCard_content__P1NfO","actions":"AncillaryCard_actions__ggfz3"};